import {computed, type Ref} from 'vue'
import type { Artikel } from '@/types/otc/artikel'
import type { Praeparat } from '@/types/otc/praeparat'

export function useProductDetailsRx(praeparat: Ref<Praeparat | null>, dictionary: Ref<Record<string, string>>) {
    const firstArtikel = computed<Artikel | null>(() => {
        return (praeparat.value?.artikel || [])[0] ?? null
    })

    const fachweltUrl = computed(() =>
        dictionary.value['PRODUKTE_fachwelturl'] ?? 'fachwelt.aliud.de'
    )

    return {
        firstArtikel,
        fachweltUrl
    }
}